import React from 'react';
import { APITypes } from '../../../../../../../primary-record-types';
import ReferenceCounts, { References } from '../../../../../../v2BaseComponents/ReferenceCounts';
import Stack from '../../../../../../v2BaseComponents/Stack';
import { getIntl } from '../../../../../../../utils/intl';
import Text from '../../../../../../v2BaseComponents/Text';
import { ReferencesDisplay } from './ReferencesDisplay';
import PressableDynamicOpacity from '../../../../../../v2BaseComponents/PressableDynamicOpacity';
import Icon from '../../../../../../v2BaseComponents/Icon';

const intl = getIntl('chat-references', {
    source: 'Source',
});

export type ChatReferencesOwnProps = {
    message: APITypes.chatService.ModelMessageComplete;
};

export type ChatReferencesProps = ChatReferencesOwnProps;

const getReferences = (referencedResources: APITypes.chatService.ModelReferencedResource[]): References => {
    const returnVal: References = {};
    for (const resource of referencedResources) {
        let category: keyof References;
        if (resource.category === 'care-team') category = 'careTeam';
        else if (resource.category === 'file-artifact') category = 'files';
        else if (resource.category === 'note') category = 'note';
        else category = resource.category;
        returnVal[category] = (returnVal[category] || 0) + 1;
    }

    return returnVal;
};

const ChatReferences: React.FC<ChatReferencesProps> = ({ message }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const hasReferences = !!message.referencedResources?.length;

    if (!hasReferences) return null;

    return (
        <Stack vertical align="flex-start" fullWidth>
            <PressableDynamicOpacity
                onPress={() => setIsOpen(!isOpen)}
                testID="chat-references-toggle"
                style={{ marginTop: 8, marginBottom: isOpen ? 8 : 0 }}
            >
                <Stack horizontal align="center" justify="flex-start" fullWidth space={2}>
                    <Icon size="minimal-button-icon" name={isOpen ? 'ChevronDown' : 'ChevronRight'} />
                    <Text variant="h6">{intl('source')}</Text>
                    <ReferenceCounts reference={getReferences(message.referencedResources || [])} />
                </Stack>
            </PressableDynamicOpacity>
            {isOpen ? (
                <Stack vertical space={1} align={'flex-start'} style={{ paddingLeft: 16 }}>
                    <ReferencesDisplay referencedResources={message.referencedResources || []} />
                </Stack>
            ) : null}
        </Stack>
    );
};

export default React.memo(ChatReferences);
